module.exports = __webpack_public_path__ + "img/left.70d31adf.png";